module.exports = __webpack_public_path__ + "static/media/item_5_20_comp.2eeb4bbd.png";